import img from '../assets/image/Banner2.png'

const data = [
    {
        "id": 1,
        "name": "Jewelry has the power to be the one little thing that makes you feel unique.",
        "dec":"Cultivate your unique approach and share your enthusiasm; the community will recognize and appreciate your efforts!",
        "img": img,
        "btn":"Shop Now",
        "position": "start",
        "speed":1
    }
];

export default data;